<template>
  <div
    v-if="!app.publishedStatus && app.hidden !== true"
    class="c-app-card__status"
  >
    <strong>Draft</strong>
  </div>

  <div
    v-if="app.publishedStatus && app.hidden !== true"
    class="c-app-card__status c-app-card__status--published"
  >
    <strong>Published</strong>
  </div>

  <div
    v-if="app.hidden === true"
    class="c-app-card__status c-app-card__status--hidden"
  >
    <strong>Hidden</strong>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AkAppPublishedStatus',

  props: {
    app: {
      default: () => ({}),
      type: Object,
    },
  },
})
</script>
<style lang="scss" scoped>
.c-app-card__status {
  z-index: 2;
}
</style>
